import * as types from './mutation-types'

const state = {
  sharesWith: [],
  membershipTitles: [],
  accessRequestFields: [],
  actAsMembershipGroupsModal: {
    open: false,
    roleId: null,
  },
}

const mutations = {
  [types.UNION_GET_SHARES_WITH](state, Union) {
    state.sharesWith = Union.shareableUnions.data
  },
  [types.ORGANIZATION_GET_MEMBERSHIP_TITLES](state, Union) {

    state.membershipTitles = _.map(Union.membershipTitles.data, function (title) {
      return {
        uuid: title.uuid,
        label: title.attributes.label,
      }
    })
  },
  [types.ORGANIZATION_GET_ACCESS_REQUEST_FIELDS](state, AccessRequestForms) {
    state.accessRequestFields =  _.flattenDeep(_.map(AccessRequestForms, function (form){
      return _.map(form.fields.data, function (field){
        return field
      })
    }))
  },
  [types.OPEN_ACT_AS_MEMBERSHIP_GROUPS_MODAL](state, roleId)
  {
    state.actAsMembershipGroupsModal.open = true
    state.actAsMembershipGroupsModal.roleId = roleId
  },
  [types.CLOSE_ACT_AS_MEMBERSHIP_GROUPS_MODAL](state)
  {
    state.actAsMembershipGroupsModal.open = false
  },
}

export default {
  state,
  mutations,
}